// extracted by mini-css-extract-plugin
export default {"productsList":"productsList__BanAr","cards":"cards__3io5j","centered":"centered__sUA_P"};
    if(module.hot) {
      // 1788784376410
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  